<template>
  <div @click="closeMenu">
    <div v-if="isDisplaySideBar" id="sidebar" class="navbar navbar-dark bg-primary">
      <span class="icon-close" @click="disPlaySideBar(false)"></span>

      <router-link to="/login" class="nav-item btn btn-primary" v-if="!isAuthenticated"
        >Login</router-link
      >
      <!-- <router-link
        to="#"
        class="nav-item btn btn-primary"
        @click="redirectToManage"
        v-if="!isAuthenticated"
        >外部プロバイダー</router-link
      > -->

      <div v-else calss="dropdown-wrapper">
        <span class="btn-primary">{{ companyService.userName }}</span>
        <div class="dropdown-wrapper">
          <router-link to="/home" class="nav-item btn btn-primary">Home</router-link>

          <Menu2 :isOpenMenu2="isMenu2Open" class="nav-item btn btn-primary" />
          <Menu3 :isOpenMenu3="isMenu3Open" class="nav-item btn btn-primary" />
          <Menu1 :isOpenMenu1="isMenu1Open" class="nav-item btn btn-primary" />
          <Menu4 :isOpenMenu4="isMenu4Open" class="nav-item btn btn-primary" />
          <Menu7 :isOpenMenu7="isMenu7Open" class="nav-item btn btn-primary" />

          <Menu5 :isOpenMenu5="isMenu5Open" class="nav-item btn btn-primary" />

          <Menu6 :isOpenMenu6="isMenu6Open" class="nav-item btn btn-primary" />

          <a @click="logout" class="nav-item btn btn-primary">ログアウト</a>
        </div>
      </div>
    </div>

    <div
      v-if="!isDisplaySideBar"
      style="
        display: flex;
        align-items: center;
        gap: 10px;
        padding-left: 0px;
        padding-top: 5px;
        padding-bottom: 0px;
      "
    >
      <button
        class="icon-arrow-right"
        :class="{ content: isDisplaySideBar }"
        @click="disPlaySideBar(true)"
      ></button>
    </div>

    <div id="content" style="padding-left: 20px" :class="{ content: isDisplaySideBar }">
      <router-view></router-view>
    </div>

    <Modal
      :modalId="modalId"
      :isModalVisible="isModalVisible"
      @cancel-action="cancelAction"
      @perform-action="performAction"
      @close-modal="closeModal"
    >
      <template v-slot:header>{{ modalTitle }}</template>
      <template v-slot:body>{{ modalMessage }}</template>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from "vue-router";
import { provide, computed, ref } from "vue";
import type { Ref } from "vue";
import Menu1 from "@/components/MenuFirst.vue";
import Menu2 from "@/components/MenuSecond.vue";
import Menu3 from "@/components/MenuThird.vue";
import Menu4 from "@/components/MenuFourth.vue";
import Menu5 from "@/components/MenuFifth.vue";
import Menu6 from "@/components/MenuSix.vue";
import Menu7 from "@/components/MenuSeven.vue";
import axios from "axios";
import store from "./store";
import Modal from "./components/MyModal.vue";
import { useModal } from "./utils/modal";
import { useToast } from "vue-toast-notification";
import CompanyService from "./Js/CompanyService";

let isMenu1Open: Ref<boolean> = ref(false);
let isMenu2Open: Ref<boolean> = ref(false);
let isMenu3Open: Ref<boolean> = ref(false);
let isMenu4Open: Ref<boolean> = ref(false);
let isMenu5Open: Ref<boolean> = ref(false);
let isMenu6Open: Ref<boolean> = ref(false);
let isMenu7Open: Ref<boolean> = ref(false);
let isDisplaySideBar: Ref<boolean> = ref(true);

const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

// モーダルの関数を提供
const {
  modalId,
  isModalVisible,
  modalTitle,
  modalMessage,
  performActionCallback,
  cancelActionCallback,
  showModal,
  showModalYesNo,
  closeModal,
  performAction,
  cancelAction,
} = useModal();
provide("modal", {
  showModal,
  showModalYesNo,
  closeModal,
  performAction,
  cancelAction,
});

// 全ての子コンポーネントで `toast` を使用可能にする
//子はconst toast: ToastPluginApi | undefined = inject("toast");と定義する。
const toast = useToast();
provide("toast", toast);

// Vuexストアから認証状態を取得
const isAuthenticated = computed(() => store.getters.isAuthenticated);

const logout = async () => {
  await showModal("確認", "ログアウトしますか", async () => {
    await axios
      .post(
        `${import.meta.env.VITE_API_TARGET}/api/account/logout`,
        {},
        { withCredentials: true }
      )
      .then(() => {
        companyService.clearStoredData();
        // ログアウト成功後の処理
        console.log("Logged out successfully.");
        store.dispatch("authenticate", false);
        // 任意のページへリダイレクトする
        window.location.href = "/";
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  });
};

const redirectToManage = () => {
  window.location.href = `${
    import.meta.env.VITE_API_TARGET
  }/Identity/Account/ExternalLogin`;
};

const closeMenu = () => {
  isMenu1Open.value = !isMenu1Open.value;
  isMenu2Open.value = !isMenu2Open.value;
  isMenu3Open.value = !isMenu3Open.value;
  isMenu4Open.value = !isMenu4Open.value;
  isMenu5Open.value = !isMenu5Open.value;
  isMenu6Open.value = !isMenu6Open.value;
  isMenu7Open.value = !isMenu7Open.value;
};

const disPlaySideBar = (isDisplay: boolean) => {
  isDisplaySideBar.value = isDisplay;
};
</script>

<style scoped>
/* width=900まで(max-width) */
@media screen and (max-width: 900px) {
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 20px;
  }

  #sidebar {
    min-width: 980px;
  }

  .content {
    margin: auto;
  }
}

/* width=901以上(min-width) */
@media screen and (min-width: 901px) {
  #sidebar {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    height: 100vh; /* Full viewport height */
    max-width: 200px; /* Adjust width as necessary */
    min-width: 200px; /* Adjust width as necessary */
    position: fixed; /* Fixed position */
    left: 0; /* Stick to the left side */
    top: 0; /* Start from the top */
    background-color: #007bff; /* Primary color */
    overflow-y: auto; /* Enable scrolling if items exceed the viewport height */
    padding: 5px; /* Padding for aesthetics */
    overflow-x: hidden;
    z-index: 1000;
  }

  .dropdown-wrapper {
    position: relative;
  }

  /* メニューボタン */
  .nav-item {
    width: 100%; /* Full width of the sidebar */
    padding-top: 10px; /* Padding for clickable area */
    padding-bottom: 10px; /* Padding for clickable area */
    color: white; /* Text color */
    text-decoration: none; /* No underline */
    box-sizing: border-box; /* Include padding in width calculation */
    float: left;
  }

  .nav-item:hover {
    background-color: #0056b3; /* Color on hover */
  }

  /* 各画面 */
  .content {
    margin-left: 200px;
    min-height: 600px;
  }
}
</style>

<style>
/* .dp__instance_calendar
{
  position: absolute;
} */

.tabs button {
  padding: 10px 20px; /* パディングを適切に設定 */
  border: solid 0.5px, #ccc;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: transparent; /* 背景を透明に設定 */
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease; /* スムーズな遷移効果 */
  color: #333; /* 通常時の文字色 */
}

.tabs button:hover {
  background-color: #f0f0f0; /* ホバー時の背景色 */
}

.tabs button.active {
  background-color: #007bff; /* アクティブなタブの背景色 */
  color: white; /* アクティブなタブの文字色 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* タブコンテナーのスタイル */
.tabs-container {
  font-family: Arial, sans-serif; /* フォントスタイルを指定 */
}

/* タブ自体のスタイル */
.tabs {
  display: flex;
  /*border-bottom: 1px solid #ccc;  下線を表示 */
}

/* タブコンテンツエリアのスタイル */
.tab-content {
  padding: 20px;
  border: 1px solid #ccc; /* 境界線 */
  /*border-top: none;  上部の境界線を削除 */
  /* overflow-x: scroll;  
   min-width: 1200px;  */
}

.pagination-container {
  display: grid;
  margin: auto;
  column-gap: 10px;
}

.paginate-buttons {
  height: 40px;

  width: 40px;

  border-radius: 20px;

  cursor: pointer;

  background-color: rgb(242, 242, 242);

  border: 1px solid rgb(217, 217, 217);

  color: black;
}

.paginate-buttons:hover {
  background-color: #d8d8d8;
}

.active-page {
  background-color: #3498db;

  border: 1px solid #3498db;

  color: white;
}

.active-page:hover {
  background-color: #2988c8;
}

.no-spin {
  width: 20px;
  text-align: right;
}
/* Chrome、Safari用 (Webkitブラウザ) */
.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox用 */
.no-spin {
  -moz-appearance: textfield;
}

/* Edge、Chrome (新EdgeはWebkit対応) */
.no-spin {
  appearance: textfield;
}

.no-spin-price {
  text-align: right;
}
/* Chrome、Safari用 (Webkitブラウザ) */
.no-spin-price::-webkit-inner-spin-button,
.no-spin-price::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox用 */
.no-spin-price {
  -moz-appearance: textfield;
}

/* Edge、Chrome (新EdgeはWebkit対応) */
.no-spin-price {
  appearance: textfield;
}

:root {
  --icon-width: 4px;
  --icon-color: black;
}

.icon-arrow-right,
.icon-arrow-top,
.icon-arrow-bottom {
  display: inline-block;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border-style: solid;
  border-width: var(--icon-width) var(--icon-width) 0 0;
  border-color: var(--icon-color);
  transform: rotate(45deg);
}
.icon-arrow-right {
  transform: rotate(45deg);
}
.icon-arrow-top {
  transform: rotate(-45deg);
}
.icon-arrow-bottom {
  transform: rotate(135deg);
}

.icon-close {
  color: white;
  width: 24px;
  height: 24px;
  position: relative;
}
.icon-close:before,
.icon-close:after {
  content: "";
  position: absolute;
  top: 12px;
  width: 24px;
  height: var(--icon-width);
  background-color: currentColor;
}
.icon-close:before {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.icon-close:after {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.colorSunday {
  color: red;
}

.colorSaturday {
  color: blue;
}

.colorRerquired {
  color: red;
  font-weight: bold;
  border: 0px;
  background-color: transparent;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

textarea {
  font-family: monospace;
}

.btn-master {
  width: 100px;
}

.btn-other {
  width: 100px;
}
</style>
